/**
 * Public-MVP feature flag.
 *
 * When `VITE_PUBLIC_MVP === 'true'`, the portal hides every non-MVP product
 * area (seller deal flow / "My Work", Director Studio, Campaigns, Debug, and
 * the self-serve campaign flow) and steers users to the paid Creative Studio
 * experience. No feature is deleted — unset the flag (or set it to anything
 * other than 'true') to fully restore the original app.
 *
 * Follows the existing env-flag convention used across the codebase
 * (e.g. VITE_ENABLE_MOCK_GENERATION, VITE_AUTH_DISABLED).
 */
export const isPublicMvp = () => import.meta.env.VITE_PUBLIC_MVP === 'true';

/**
 * Whether a Stripe payment is required before creative generation.
 *
 * Defaults to ON whenever public-MVP mode is on (so internal/seller usage with
 * the flag off is unaffected). Can be forced independently with
 * `VITE_REQUIRE_PAYMENT` = 'true' | 'false'.
 */
export const isPaymentRequired = () => {
  const explicit = import.meta.env.VITE_REQUIRE_PAYMENT;
  if (explicit === 'true') return true;
  if (explicit === 'false') return false;
  return isPublicMvp();
};

/**
 * The path the app treats as an organization's "home". In MVP mode this is the
 * Creative Studio; otherwise it is the seller work queue (the original home).
 */
export const orgHomePath = (orgSlug) =>
  isPublicMvp() ? `/org/${orgSlug}/creatives` : `/org/${orgSlug}/leads`;
